import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100% ',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    backgroundColor: Colors.lightGray,
    padding: '1.25rem',
    borderRadius: 5,
    border: `1px solid ${Colors.gray}`,
    gap: '1rem',
    textAlign: 'justify',
  },

  answerWrapper: {
    width: '100%',
    backgroundColor: Colors.white,
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
  },
  
  questionText: {
    '& span': {
      fontWeight: 600,
    },
    padding: '0 0 2rem 0',
    fontStyle: 'italic',
    fontSize: '1.6rem',
    wordWrap: 'break-word',
  },
  
}))

export default styles
